package dev.akshaychordiya.content

class BookLink(val label: String, val url: String)

/**
 * @param coverUrl Optional. Drop a cover into `resources/public/images/books/` and reference it here; the card falls
 *   back to a typographic treatment when there isn't one, so a missing cover never shows as a broken image.
 * @param inProgress Marks a book that isn't finished, so the page can say so rather than implying it's buyable.
 */
class Book(
    val title: String,
    val subtitle: String,
    val year: String,
    val publisher: String,
    val description: String,
    val coAuthors: List<String> = emptyList(),
    val links: List<BookLink> = emptyList(),
    val coverUrl: String? = null,
    val inProgress: Boolean = false,
)

val books = listOf(
    Book(
        title = "Kotlin Blueprints",
        subtitle = "A practical guide to building industry-grade applications in Kotlin",
        year = "2017",
        publisher = "Packt Publishing",
        description = "Building real web, mobile and desktop applications in Kotlin - covering Spring Boot, " +
            "Node.js, Android and desktop, with the trade-offs that come up once a Kotlin project grows past a demo.",
        coAuthors = listOf("Ashish Belagali", "Hardik Trivedi"),
        coverUrl = "/images/books/kotlin-blueprints.webp",
        links = listOf(
            BookLink("Amazon", "https://www.amazon.com/dp/1788390806"),
            BookLink("Apple Books", "https://books.apple.com/us/book/kotlin-blueprints/id1324642920"),
        ),
    ),
)

/**
 * Shown under the book list.
 *
 * Deliberately says nothing about the subject or title - there is a second book in progress but it isn't being
 * announced yet. Fill this in when you're ready to talk about it, or set it to an empty string to hide the line.
 */
const val NEXT_BOOK_TEASER = "A second book is in the works."
